import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import thunk from 'redux-thunk';
import loginReducer from './store/reducers/Login';
import msgReducer from './store/reducers/Msgs';
import dialerReducer from './store/reducers/Dialer'
import contactReducer from './store/reducers/contactReducer'
import notificationReducer from './store/reducers/notifications'
import settingsReducer from './store/reducers/Settings'
import crmReducer from './store/reducers/Crm'
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/fontawesome/css/all.css';
import 'emoji-mart/css/emoji-mart.css'
import common_heb from "./translations/heb/common.json";
import common_en from "./translations/en/common.json";
import crm_heb from "./translations/heb/crm.json";
import crm_en from "./translations/en/crm.json";
import { AlertContextProvider } from './context/AlertModelContext/AlertModalContext'
import { ConfirmationModalProvider } from './context/ConfirmationModalContext/ConfirmationModalContext';
import * as settings from './settings'
import { SearchInquiresProvider } from './context/SearchContactInquires/SearchContactInquires';
// require("flatpickr/dist/themes/material_blue.css");
import 'flatpickr/dist/themes/material_blue.css'
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import dayjs from 'dayjs';

// Set global locale
dayjs.locale('he');

// Create RTL cache
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [rtlPlugin],
});

// Optional: use MUI theme customization
const theme = createTheme({
  direction: 'rtl',
});


i18next.init({
  interpolation: { escapeValue: false },  // React already does escaping
  lng: 'he',                              // language to use
  ns: ['common', 'crm'],   // list of namespaces
  defaultNS: 'common',     // <-- set this!
  resources: {
    en: {
      common: common_en,// 'common' is our custom namespace
      crm: crm_en
    },
    he: {
      common: common_heb,
      crm: crm_heb
    },
  },
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const rootReducer = combineReducers({
  login: loginReducer,
  msgs: msgReducer,
  dialer: dialerReducer,
  settings: settingsReducer,
  notifications: notificationReducer,
  contacts: contactReducer,
  crm: crmReducer
});

const store = createStore(rootReducer, process.env.NODE_ENV !== "development" ? compose(applyMiddleware(thunk)) : composeEnhancers(applyMiddleware(thunk))
);

const app = () => (
  <Provider store={store}>
    <I18nextProvider i18n={i18next}>
      <BrowserRouter>

        {/* <React.StrictMode> */}
        <AlertContextProvider>
          <ConfirmationModalProvider>
            <SearchInquiresProvider>
              <GoogleOAuthProvider clientId={settings.googleClientId}>
                <CacheProvider value={cacheRtl}>
                  <ThemeProvider theme={theme}>
                    <App />
                  </ThemeProvider>
                </CacheProvider>
              </GoogleOAuthProvider>
            </SearchInquiresProvider>
          </ConfirmationModalProvider>
        </AlertContextProvider>
        {/* </React.StrictMode> */}

      </BrowserRouter>
    </I18nextProvider>
  </Provider>

);

ReactDOM.render(
  app(),
  document.getElementById('root')

);

// Comprehensive ResizeObserver error suppression
// These errors are benign and don't affect functionality - they're just browser warnings

// Method 1: Patch ResizeObserver to debounce callbacks and prevent loops
if (typeof ResizeObserver !== 'undefined') {
  const OriginalResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      // Wrap callback to catch and suppress errors
      const wrappedCallback = (entries, observer) => {
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (e) {
            // Silently catch ResizeObserver errors
            if (!e.message || !e.message.includes('ResizeObserver')) {
              throw e; // Re-throw if it's not a ResizeObserver error
            }
          }
        });
      };
      super(wrappedCallback);
    }
  };
}

// Method 2: Catch error events
window.addEventListener('error', (e) => {
  if (e.message && (
    e.message.includes('ResizeObserver loop completed with undelivered notifications') ||
    e.message.includes('ResizeObserver loop limit exceeded') ||
    e.message.includes('ResizeObserver')
  )) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    if (e.preventDefault) e.preventDefault();
    return true;
  }
});

// Method 3: Override console methods
const originalConsoleError = console.error;
console.error = function(...args) {
  const msg = args[0]?.toString() || '';
  if (msg.includes('ResizeObserver')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

const originalConsoleWarn = console.warn;
console.warn = function(...args) {
  const msg = args[0]?.toString() || '';
  if (msg.includes('ResizeObserver')) {
    return;
  }
  originalConsoleWarn.apply(console, args);
};

if (process.env.NODE_ENV !== "development") console.log = () => { };

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

  navigator.serviceWorker.register(swUrl).then(reg => {
    // ---- 1.  A previously waiting SW is ready ----
    if (reg.waiting) {
      reg.waiting.postMessage({ type: 'SKIP_WAITING' });
    }

    // ---- 2.  A new SW is downloading ----
    reg.onupdatefound = () => {
      const newSW = reg.installing;
      if (!newSW) return;

      newSW.onstatechange = () => {
        if (newSW.state === 'installed' && navigator.serviceWorker.controller) {
          // new SW installed, prompt or auto-reload
          if (window.confirm(i18next.t('New version available. Reload?'))) {
            newSW.postMessage({ type: 'SKIP_WAITING' });
          }
        }
      };
    };
  });

  // ---- 3.  When the new SW activates, reload the page ----
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
